import { CropYear } from "../../cropYear"
import { isDate } from "../../utils/utils"

export function checkDatesAndCroppingYear(start: Date, end: Date, year: CropYear) {

    let ok = true
    let invalidYear = false
    let twoYears = false

    if (year && isDate(start) && isDate(end)) {

        if ((start > year.EndDate) || (end < year.StartDate)) {
            ok = false
        }

        if ((start < year.StartDate) && (end > year.EndDate)) {
            ok = false
        }

    } else if (year && isDate(start)) {

        if (start < year.StartDate || start > year.EndDate) {
            ok = false
        }

    }

    if (!ok) {
        invalidYear = true
    }

    const startYear = isDate(start) ? CropYear.getYearFromDate(start) : year.YearId
    const endYear = isDate(end) ? CropYear.getYearFromDate(end) : year.YearId
    const span = endYear - startYear

    if ((span < 0) || (span > 1)) {
        twoYears = true
    }

    return {
        invalidYear,
        twoYears
    }

}

export function checkPerennialCroppingYear(date: Date, startDate: boolean, firstCroppingYear: number, lastCroppingYear: number) {

    const year = CropYear.getYearFromDate(date);

    const valid = startDate
        ? ((year >= firstCroppingYear) && (year <= lastCroppingYear))
        : (year >= firstCroppingYear)

    return valid

}

export function checkNonPerennialDestructionDate(end: Date, destroyed: boolean, cropYear: CropYear) {

    if (!destroyed) return true

    const nextYear = new CropYear(cropYear.YearId + 1)
    const nextYearEnd = nextYear.EndDate

    return (end <= nextYearEnd)
}
